import {
  OrderCargoOrderHistoryDataRideSeqItem,
  OrderCargoOrderHistoryItemInitializeCommandRideWaypoint,
} from "../../../../../common/services/order/cargo-order/history/order-cargo-order-history";

const checkIsResponseRideSeqItemAWaypoint = (
  responseRideSeqItem: OrderCargoOrderHistoryDataRideSeqItem,
): responseRideSeqItem is OrderCargoOrderHistoryItemInitializeCommandRideWaypoint => {
  if (
    (
      responseRideSeqItem as OrderCargoOrderHistoryItemInitializeCommandRideWaypoint
    ).displayName
  ) {
    return true;
  }

  return false;
};

const orderDetailsHistoryOrderRouteHelper = {
  checkIsResponseRideSeqItemAWaypoint,
};

export default orderDetailsHistoryOrderRouteHelper;
